import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from '@thd-olt-component-react/router';
import ConfirmDialog from '../../common/ConfirmDialog/ConfirmDialog';
import { useStore } from '../../../store/index';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { EXP_ROUTES, JOB_POSTING_STATUS } from '../../../utils/constants';
import { clickEvents } from '../../../utils/analytics';
import { jobPostingValidators } from '../../../utils/validations';

const UnsavedWorkDialog = ({ setShowErrors, scrollToError }) => {
  const {
    jobPostingStore: {
      pendingSaveAsDraftPosting,
      pendingPublishingJobPosting,
      toggleUnsavedWorkModal,
      saveJobPosting
    }
  } = useStore();

  const {
    editedJobPosting, canSaveAsDraft
  } = useContext(JobPostingContext);

  const navigate = useNavigate();

  const handleClose = (jobPostingId) => {
    toggleUnsavedWorkModal();
    if (jobPostingId !== undefined) {
      window.setTimeout(() => {
        navigate(EXP_ROUTES.JOB_POSTING(jobPostingId));
      }, 100);
    } else {
      navigate(EXP_ROUTES.JOB_POSTINGS);
    }
  };

  const handleSaveAsDraft = () => {
    if (canSaveAsDraft()) {
      clickEvents.postingDetailsModifications('save as draft');
      saveJobPosting(composeDataForSubmit(JOB_POSTING_STATUS.DRAFT), handleClose);
    } else {
      toggleUnsavedWorkModal();
      setShowErrors({ draft: true, publish: true });

      scrollToError();
    }
  };

  const composeDataForSubmit = (status) => {
    return {
      ...editedJobPosting,
      companyUrl: editedJobPosting.companyUrl || null,
      sharing: status === 'ACTIVE',
      yearsOfExperience: jobPostingValidators.yearsOfExperience(editedJobPosting) ? editedJobPosting.yearsOfExperience : null,
      status
    };
  };

  return (
    !pendingPublishingJobPosting && (
      <ConfirmDialog
        headerText="Unsaved Work"
        open={!!pendingSaveAsDraftPosting}
        onConfirm={() => handleSaveAsDraft()}
        onClose={() => handleClose()}
        onCloseButtonX={() => toggleUnsavedWorkModal()}
        confirmTestId="confirm-publish-job-posting"
        confirmText="Save as Draft"
        cancelText="Cancel Posting"
      >
      Are you sure you want to cancel this job and return back to all job postings?
        <br />
        <b>Your work will be lost.</b>
        <br />
      Make sure to save your work if you want to return later.
      </ConfirmDialog>
    )
  );
};

export default observer(UnsavedWorkDialog);
